import { Contact } from 'modules/Contacts/models/models';
import {
  Document,
  DocumentType,
  VisualLine,
  Concept,
} from 'modules/Documents/models/document';
import { ReceiptStatus } from 'modules/Documents/models/receiptStatus';
import {
  VerifactuInvoiceType,
  VerifactuDisplayLine,
  VerifactuLine,
} from 'modules/Documents/models/verifactuDocument';
import { VerifactuInvoice } from 'modules/Documents/models/verifactuInvoice';

import { normalizeVerifactuCounterpartyToContact } from './normalizeVerifactuCounterpartyToContact';
import { normalizeVerifactuDisplayLineToConcept } from './normalizeVerifactuDisplayLineToConcept';
import { normalizeVerifactuInvoiceTypeToStatusInfo } from './normalizeVerifactuInvoiceTypeToStatusInfo';
import { normalizeVerifactuLineToConcept } from './normalizeVerifactuLineToConcept';
import { normalizeVerifactuOwnerToBusiness } from './normalizeVerifactuOwnerToBusiness';
import { normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses } from './normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses';
import { normalizeVerifactuTaxAuthorityToDocument } from './normalizeVerifactuTaxAuthorityToDocument';
import { normalizeVerifactuTotalsToDocumentTotals } from './normalizeVerifactuTotalsToDocumentTotals';

export function normalizeVerifactuInvoiceToDocument(
  verifactu: VerifactuInvoice
): Document {
  const visualLines: VisualLine[] =
    verifactu.displaySettings.lines.length > 0
      ? processVisualLines(verifactu.displaySettings.lines)
      : [];

  const additionalExpenses =
    verifactu?.reimbursableExpenseLines &&
    verifactu.reimbursableExpenseLines.length > 0
      ? normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses(
          verifactu.reimbursableExpenseLines
        )
      : [];

  const receiptStatus =
    verifactu.type === VerifactuInvoiceType.Receipt
      ? ReceiptStatus.IS_RECEIPT
      : undefined;
  return {
    id: verifactu.id,
    code: verifactu.invoiceNumber,
    serialCode: verifactu.seriesCode,
    identifier: verifactu.fullInvoiceNumber,
    ownerContact: normalizeVerifactuOwnerToBusiness(verifactu.frozenOwner),
    isFreezed: false, // ⚠️ Falta isFreezed
    totalAmountFromPayments: 0, // ⚠️ Falta totalAmountFromPayments
    documentType: DocumentType.INVOICE,
    status: verifactu.status,
    issuedDate: verifactu.issuedDate,
    issuedDateTime:
      verifactu.issuedAt && new Date(verifactu.issuedAt).toISOString(),
    operationDateTime: verifactu.operationDate,
    operationDescription: verifactu.operationDescription,
    taxRegime: verifactu.taxRegime,
    templateId: verifactu?.displaySettings?.template?.id,
    comments: verifactu.comments,
    reference: verifactu.reference,
    dueDate: verifactu.dueDate,
    currency: verifactu.currency,
    concepts: processConcepts(verifactu.lines),
    statusInfo: normalizeVerifactuInvoiceTypeToStatusInfo(
      verifactu.type,
      verifactu.status
    ),
    contact: normalizeVerifactuCounterpartyToContact(verifactu) as Contact,
    totals: normalizeVerifactuTotalsToDocumentTotals(verifactu),
    digitalDocument: normalizeVerifactuTaxAuthorityToDocument(verifactu),
    receiptStatus,
    additionalExpenses,
    visualLines,
  };
}

const processVisualLines = (lines: VerifactuDisplayLine[]) => {
  const visualLines: VisualLine[] = [];

  lines.forEach((line) => {
    const concept = normalizeVerifactuDisplayLineToConcept(line);
    visualLines.push(concept);
  });

  return visualLines;
};

const processConcepts = (lines: VerifactuLine[]) => {
  const concepts: Concept[] = [];

  lines.forEach((line) => {
    const concept = normalizeVerifactuLineToConcept(line);
    concepts.push(concept);
  });

  return concepts;
};
